import { getListOfWhatsappPrice2 } from "../types/gateway_and_price_list_whatsapp_types";

const initState = {

  data: [],
  count: 0,
  loading: false,
  error: null,
};

export default function gatewayAndPriceListWhatsappReducer(state = initState, action = {}) {
  switch (action.type) {

    case getListOfWhatsappPrice2.GET_LIST_OF_WHATSAPP_PRICE_2_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getListOfWhatsappPrice2.GET_LIST_OF_WHATSAPP_PRICE_2_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        count: action.payload.count,
        error: null,

      };
    case getListOfWhatsappPrice2.GET_LIST_OF_WHATSAPP_PRICE_2_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
